<template>
    <v-dialog v-model="dialogLineitem" scrollable persistent :overlay="false" max-width="500px" transition="dialog-transition" >
      <v-card  >
        <v-card-title primary-title>
          {{ dialogLineitemTitle }} <v-spacer></v-spacer> <v-btn color="black" icon @click="resetDialog"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-card-text>
          <v-row dense>
            <v-col cols="6" class="py-0">
              <v-select :items="filteredProducts" v-model="selectedProduct" label="Product" item-text="name" item-value="id" return-object @change="applyProduct"></v-select>
            </v-col>
            <v-col cols="2" class="py-0">
              <v-text-field label="Quantity" v-model.number="lineitem.quantity" @input="sumPrice"></v-text-field>
            </v-col>
            <v-col cols="4" class="py-0">
              <v-text-field label="Price" v-model.number="lineitem.price"></v-text-field>
            </v-col>
            <v-col cols="6" class="py-0">
              <v-text-field label="Serial" v-model="lineitem.serial"></v-text-field>
            </v-col>
            <v-col cols="6" class="py-0">
              <v-text-field label="License" v-model="lineitem.license"></v-text-field>
            </v-col>
            <v-text-field label="Note" v-model="lineitem.note"></v-text-field>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-btn block color="primary" @click="addLineitem">{{ dialogLineitemBtn }}</v-btn>
        </v-card-actions>
      </v-card>

    </v-dialog>
  </template>

<script>
  export default {
    props: {
      item: {
        type: Object,
        default: () => ({ })
      },
    },
    data(){
      return {
        dialogLineitem: false,
        selectedProduct: { },
        lineitem:{ quantity:0, price: 0, license: '', serial: '' },
        shippings: [ 'TIKI Reg', 'TIKI ONS', 'JNE Reg', 'JNE YES', 'SiCepat', 'AnterAja', 'Pos Express' ]
      }
    },

    computed:{
      filteredProducts(){
        return this.$store.state.products
      },
      dialogLineitemTitle(){
        return (this.lineitem.id) ? "Edit item" : "Add item"
      },
      dialogLineitemBtn(){
        return (this.lineitem.id) ? "Update" : "Save"
      },

      // price(){
      //   if(!this.lineitem.quantity) return 0
      //   if(!this.lineitem.price) return 0
      //   return this.lineitem.quantity * this..price
      // }

    },


    methods: {
      assignItem(item){
        this.lineitem = Object.assign({},item)
      },

      applyProduct(val){
        this.lineitem.quantity = 1
        this.lineitem.price = val.price
        this.lineitem.productId = val.id
      },

      sumPrice(){
        this.lineitem.price = this.lineitem.quantity * this.selectedProduct.price
      },

      resetDialog(){
        this.dialogLineitem = false
        this.lineitem = { quantity:0, price: 0 };
        this.selectedProduct = {}
      },

      addLineitem(){
        this.lineitem.productName = this.selectedProduct.name
        this.$emit('closeDialog', this.lineitem );
        this.lineitem = { }
        this.selectedProduct = {}
      }
    }

  }
</script>